/**
 * The name a duplicate starts with: the original's name without any run
 * number, then the next number no experiment uses yet — "Triage" gives
 * "Triage #2", and with "Triage #2" taken, "Triage #3".
 */

const NUMBER = / #(\d+)$/;

export function copyName(name: string, taken: string[]): string {
  const base = name.trim().replace(NUMBER, "");
  const used = taken.map((t) => {
    const n = t.trim();
    if (n === base) return 1;
    const m = n.startsWith(base) ? /^ #(\d+)$/.exec(n.slice(base.length)) : null;
    return m ? Number(m[1]) : 0;
  });
  return `${base} #${Math.max(1, ...used) + 1}`;
}
